import React from 'react'

export const AboutScrumBill = () => <div class="bordered-panel">

<h4>About ScrumBill</h4>

ScrumBill is a site for people who need to log their work efforts for projects or contracts.

</div>
